export const GET_ERRORS = "GET_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_LABELS = "SET_LABELS";
export const PROFILE_NOT_FOUND = "PROFILE_NOT_FOUND";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_SEARCH = "SET_SEARCH";
export const SET_DATA = "SET_DATA";
